import { sanitizeLabel } from 'shared/helpers/sanitizeData';

/** Normalize label title for create/update (same rules as quick-create search sanitize). */
export function normalizeLabelTitle(value = '') {
  return sanitizeLabel(value);
}
